import { auth, firebase } from "./firebase"

export default {
  loginWithGoogle() {
    const provider = new firebase.auth.GoogleAuthProvider()
    return auth.signInWithPopup(provider)
  },

  loginWithEmail(email, password) {
    return auth.signInWithEmailAndPassword(email, password)
  },

  sendPasswordResetEmail(email) {
    firebase.auth().useDeviceLanguage()
    return auth.sendPasswordResetEmail(email, { url: window.location.origin })
  },

  signUpWithEmail(email, password) {
    return auth.createUserWithEmailAndPassword(String(email), String(password))
  },

  loginWithCustomToken(token) {
    return auth.signInWithCustomToken(token)
  },

  onAuthChanged(callback, errorCallback) {
    this.authUnsubscribe = auth.onAuthStateChanged(callback, errorCallback)
  },

  authUnsubscribe: null,

  offAuthChanged() {
    if (this.authUnsubscribe != null) {
      this.authUnsubscribe()
      this.authUnsubscribe = null
    }
  },

  logout() {
    return auth.signOut()
  }
}
